// extracted by mini-css-extract-plugin
module.exports = {"hidden":"addcomment_hidden__31WXD","addcomment":"addcomment_addcomment__hTkal"};